import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { TableChart } from '@workwave-tidal/core/icons'
import { FilePreview } from '@workwave-tidal/lab'
import { useFormikContext } from 'formik'
import { GetTemplateResponse, ImportUtilityModel } from '../../typings'
import { useQuery } from 'react-query'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'
import { entityTypeToImportType } from '../../../typings'

const fileName = {
  pendingLeads: 'Pending_Lead_Import_Template.csv',
  leads: 'Lead_Import_Template.csv',
  opportunities: 'Opportunity_Import_Template.csv',
}

export function TemplateDownloadSection() {
  const { values } = useFormikContext<ImportUtilityModel>()

  const importType = React.useMemo(() => {
    return entityTypeToImportType(values.entityType)
  }, [values.entityType])

  const { data, isFetching, refetch } = useQuery(
    ['importTemplate'],
    async () => {
      const result = await get(
        `${ServiceConfig.baseAPIUrl}/Import/templates/${importType}`,
      )
      if (result instanceof Response && result.ok) {
        const response: GetTemplateResponse = await result.json()

        return response
      }
    },
  )

  React.useEffect(() => {
    refetch()
  }, [values.entityType, refetch])

  const onDownloadClick = React.useCallback(() => {
    if (data) {
      const file = data.file
      const csvContent = atob(file.fileContents)
      const blob = new Blob([csvContent], { type: file.contentType })
      const objectURL = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = objectURL
      link.setAttribute('download', `${data.name}`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(objectURL)
    }
  }, [data])
  importType
  return (
    <Box mb={3.2}>
      <Typography variant="h7">Download Template</Typography>
      <Typography variant="body1">
        Download the template to use to import your records.
      </Typography>

      <Box mt={1} width={'80%'}>
        <FilePreview
          onClick={onDownloadClick}
          disabled={isFetching}
          loading={isFetching}
          icon={<TableChart sx={{ color: '#A6CB72' }} />}
          title={data?.name || fileName[importType]}
          tooltip=""
          subtitle={data?.size || ''}
          variant="standard"
        />
      </Box>
    </Box>
  )
}
